import { useMemo } from 'react'

import { getBrand } from 'pared/utils/brand'

import { IPropsType as IChatboxV2PropsType } from '../../../../Routes/renderer/chatBoxV2'

interface IConfig extends Omit<IChatboxV2PropsType, 'type' | 'sendStoreId'> {
  enableChat: boolean
}

const defaultConfig: IConfig = {
  enableChat: false,
  agentCode: 'systemwide-salesmanship',
}

export default (): IConfig => {
  const brand = getBrand()

  return useMemo(() => {
    switch (brand) {
      case 'wingitnorth':
        return {
          ...defaultConfig,
          enableChat: true,
          hideFromNonExpoUsers: true,
        }

      case 'timoney_bk':
      case 'ghai_pop':
      case 'irmg_bk':
      case 'mwb':
        return {
          ...defaultConfig,
          enableChat: true,
        }

      default:
        return defaultConfig
    }
  }, [brand])
}
